import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useWindowSize } from "src/hooks";
import { isProductionEnv } from "src/utils";
import { selectWhiteLabel } from "src/store/selectors";
import { HIDDEN_INTERCOM_WHITE_LABELS } from "src/constants";

export const useIntercomVisibility = () => {
  const { isMobileView } = useWindowSize();
  const whiteLabel = useSelector(selectWhiteLabel);
  const isProduction = isProductionEnv();
  const intercomClient = window.Intercom;

  useEffect(() => {
    if (!isProduction || !intercomClient || !whiteLabel?.id) return;

    // Hide Intercom for specific white labels
    const shouldHideIntercom =
      HIDDEN_INTERCOM_WHITE_LABELS.includes(whiteLabel.id) || isMobileView;

    intercomClient("update", {
      hide_default_launcher: shouldHideIntercom,
    });

    if (shouldHideIntercom) {
      intercomClient("hide");
    }
  }, [intercomClient, isMobileView, isProduction, whiteLabel.id]);
};
